/**
 * @file Re-exports the investment form.
 */
import InvestmentForm from "./InvestmentForm";

export default InvestmentForm;
